const IconMinus = props => (
	<svg xmlns="http://www.w3.org/2000/svg" {...props} viewBox="0 0 12 2" fill="none">
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M0.166504 1C0.166504 0.723858 0.390362 0.5 0.666504 0.5H11.3332C11.6093 0.5 11.8332 0.723858 11.8332 1C11.8332 1.27614 11.6093 1.5 11.3332 1.5H0.666504C0.390362 1.5 0.166504 1.27614 0.166504 1Z"
			fill="currentColor"
		/>
	</svg>
);

export default IconMinus;
